import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function Brand(_a) {
    var src = _a.src, link = _a.link, alt = _a.alt;
    var brand = src ? _jsx("img", { src: src, alt: alt }) : alt;
    return _jsx(_Fragment, { children: link ? _jsx("a", { href: link, children: brand }) : brand });
}
//# sourceMappingURL=Brand.js.map